export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "highlight_worker.6434fa9a.worker.js");
}
